<template>
  <ValidationObserver @submit="updateNotificationReceiversHandler">
    <UiModalContainer
      footer-classes="flex justify-end gap-3"
      :modal-show="showModel"
      :modal-width="40"
      @handleClick="handleClick"
    >
      <template v-slot:header>
        <span>{{ featureAndActions?.title || 'Notification Settings' }}</span>
      </template>
      <template v-slot>
        <div class="flex flex-wrap pt-4">
          <div class="flex w-full flex-wrap px-3 mt-3">
            <div class="md:w-1/2 w-full px-2">
              <UiSingleSelect
                v-model="notificationData.role"
                :select-object-without-reduce-key="true"
                title="RECEIVER_S"
                rules="required"
                label="name"
                :options="options"
                :disabled="isUpperLevelTrigger || !!edit"
                :allow-html-tool-tip-for-long-text="true"
                class="text-text-color font-roboto text-sm font-normal flex-1"
              />
            </div>
            <div class="md:w-1/2 w-full px-2 md:mb-0 mb-5">
              <UiMultiSelect
                v-model="notificationData.except"
                :dynamic-title="true"
                :title="`Select ${notificationData.role?.name || 'Users'}`"
                :already-selected="alreadyExcluded"
                label="full_name"
                :options="usersList"
                :search-through-api="true"
                class="text-text-color font-roboto text-sm font-normal flex-1"
                @search="_getRoledata"
              />
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div class="flex gap-3 rtl:gap-x-4">
          <UIButton @click="handleClick('close')">Cancel</UIButton>
          <UIButton button="primary">
            <span v-if="modalButtonLoading">
              <Loader />
            </span>
            <span v-else>Save</span>
          </UIButton>
        </div>
      </template>
    </UiModalContainer>
  </ValidationObserver>
</template>

<script>
import NOTIFICATION_FEATURES_NAME from '@src/constants/notification-constants.js'
import UiSingleSelect from '@components/UiElements/UiSingleSelect.vue'
import { Form as ValidationObserver } from 'vee-validate'

import * as GENERAL_CONSTANTS from '@src/constants/general-constants'
import UiMultiSelect from '@/src/components/UiElements/UiMultiSelect.vue'
import { buildWhereQuery } from '@/src/utils/filters'
import { mapActions, mapState } from 'vuex'
import FILTER_KEYS from '@src/constants/filter-constants.js'
import UiModalContainer from '@components/UiElements/UiModalContainer.vue'
import Loader from '@components/BaseComponent/Loader.vue'
import UIButton from '@src/components/UiElements/UIButton.vue'
import { isArray } from 'lodash'
import { fullName } from '@src/utils/settings/tenant-user.util.js'

export default {
  name: 'CreateEditFeePublishAlert',
  components: {
    UiModalContainer,
    Loader,
    ValidationObserver,
    UiSingleSelect,
    // ToggleButton,
    UiMultiSelect,
    UIButton,
  },
  props: {
    showModel: {
      type: Boolean,
      default: false,
    },
    options: { type: Array, default: () => GENERAL_CONSTANTS.ROLES_LIST },
    edit: { type: Object, default: () => null },
    featureAndActions: { type: Object, default: () => ({}) },
    module: {
      type: String,
      default: '',
    },
    receiverIndex: { type: Number, default: null },
  },

  emits: ['handleClick', 'addNotificationAlert', 'update'],
  data() {
    return {
      notifications: 'notifications',
      modalButtonLoading: false,
      GENERAL_CONSTANTS,
      usersList: [],
      alreadyExcluded: [],
      notificationData: {
        role: null,
        except: [],
      },
      isUpperLevelTrigger: false,
    }
  },
  created() {
    this._getStaffData()
    if (this.edit) {
      this.handleEditData(this.edit)
    }
  },
  methods: {
    fullName,

    handleEditData(val) {
      if (val) {
        this.notificationData.role = val.send_to
        this.notificationData.user = val?.id
        this.notificationData.action = val.action
        this.notificationData.feature = val.feature
        this.notificationData.send_to = val.send_to
        this.notificationData.receiver_role_id = val.receiver_role_id
        this.notificationData.medium = val.mediums[this.receiverIndex]
        this.alreadyExcluded = this.receiversFor(val.user_receivers[this.receiverIndex]) || []
      }
    },

    _getRoledata(query = '') {
      this._getStaffData(query)
    },

    handleClick() {
      this.$emit('update', 'close')
    },

    async updateNotificationReceiversHandler() {
      if (this.modalButtonLoading) return
      this.modalButtonLoading = true

      const data = {
        feature: this.notificationData.feature,
        action: this.notificationData.action,
        send_to: this.notificationData.send_to,
        medium: this.notificationData.medium,
        receiver_role_id: this.notificationData.receiver_role_id,
        receiver_ids: this.notificationData.except?.map((user) => user.id) || [],
      }

      try {
        await this.defaultNotifications(data)
      } finally {
        this.modalButtonLoading = false
      }
    },

    async defaultNotifications(data) {
      let res
      if (this.edit) {
        res = await this.upsertReceivers(data)
      }
      if (res) {
        this.$emit('update', this.featureAndActions, {}, true)
      }
    },
    async _getStaffData(query = '') {
      const payload = {
        $where: {
          ...buildWhereQuery(FILTER_KEYS.ILIKE, 'search', query),
        },
      }
      const response = await this.getStaffWithFilters(payload)
      if (response?.data?.records) {
        this.usersList = response.data.records.map((user) => {
          user.receiver_user_id = user.id
          return user
        })
      }
    },
    receiversFor(notification_trigger_receivers) {
      if (!isArray(notification_trigger_receivers)) {
        return []
      }
      return notification_trigger_receivers
        .map((user) => (user ? user.receiver : null))
        .filter(Boolean)
        .map((r) => {
          const receiver = {
            ...r,
          }
          this.fullName(receiver)
          return receiver
        })
    },

    ...mapActions('staff', ['getStaffWithFilters']),
    ...mapActions('notifications', ['upsertReceivers']),
  },
}
</script>
